import { formatPriceParams } from '../../types';
import { formatToMarketSpecificCurrency, SupportedLocale } from '@workbench/core';
/**
 *
 * @param params object which passes 'min', 'max', 'unit' from price
 * and 'language', 'country' from store response in order to set local properly.
 * @param minOrMax 'min' or 'max' -
 * defining which price property do we need to format and return.
 * @returns formatted price string, for example: 123.456,79 €
 */
export const formatPrice = (params: formatPriceParams, minOrMax: string): string => {
  const countryAndLanguage = `${params.language}-${params.country}` as SupportedLocale;
  const priceToFormat = Number(minOrMax === 'min' ? params.min : params.max);
  const formattedPrice: string = formatToMarketSpecificCurrency(priceToFormat, countryAndLanguage);
  return formattedPrice;
};
